import { createStore } from "@stencil/store";
import { TMetier } from "./types";

type User = {
    id: string;
    username: string;
    email: string;
    client: string;
};

type Client = {
    code: string;
    name: string;
};

type StoreData = {
    colors: Record<
        string,
        {
            primary: string;
            secondary: string;
        }
    >;
    metiers: Record<string, TMetier>;
    domains: Record<
        string,
        {
            id: string;
            domain: string;
        }
    >;
    mappings: Record<string, string[]>;
    hierarchy: Record<string, string[]>;
};

type StoreState = {
    user: User | null | undefined;
    client: Client | undefined;
    data: StoreData;
};

const initialState: StoreState = {
    user: undefined,
    client: undefined,
    data: {
        colors: {},
        metiers: {},
        domains: {},
        mappings: {},
        hierarchy: {},
    },
};

export default createStore<StoreState>(initialState);
